import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MtAccount } from "server/models"
import { deepCopy, StateType } from "client/utils"
import { mtAccountsRoute } from "client/parts/routes"
import {
    StoreType,
    AccountList,
    AccountFilters,
    AccountPackageList,

    LoadAllAccounts,
    LoadAllAccountPackages,
    ChangeAccountStatus,
    SortAccounts,

    setAccountList,
    setAccountIds,
    setAccountSort,
    setAccountFilters,
    setAccountPackageList,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    ChangeStatus,
} from "client/components"

import AccountSearch from "client/pages/search/accountSearch"
import Columns from "./columns"


const List = () => {
    const accountPackageList = useSelector((state: StoreType) => state.accountPackage.accountPackageList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)
    const accountIds = useSelector((state: StoreType) => state.account.accountIds)
    const sortColumn = useSelector((state: StoreType) => state.account.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.account.sortOrder)
    const filters = useSelector((state: StoreType) => state.account.filters)
    const reloadList = useSelector((state: StoreType) => state.account.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        const promiseArray = [
            LoadAllAccounts().then((res) => {
                dispatch(setAccountList(res))
            }),
            LoadAllAccountPackages().then((res) => {
                dispatch(setAccountPackageList(res))
            }),
        ]
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortAccounts(Object.values(accountList), sortColumn, sortOrder, filters, accountPackageList as AccountPackageList)
        dispatch(setAccountIds(sortedIds))
    }, [accountList, sortColumn, sortOrder, filters, accountPackageList])

    const onSort: SortRows = (column: keyof MtAccount, order) => {
        dispatch(setAccountSort(column, order))
    }

    const onFilter = (newFilters: AccountFilters) => {
        dispatch(setAccountFilters(newFilters))
    }

    const onStatusChange: ChangeStatus = (account: MtAccount, callback) => {
        ChangeAccountStatus(account).then((status) => {
            callback(() => {
                const accountListCopy: AccountList = deepCopy(accountList)
                accountListCopy[account.id] = {
                    ...accountListCopy[account.id],
                    status,
                }
                dispatch(setAccountList(accountListCopy))
            })
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.accounts}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <AccountSearch
                        id="accountList"
                        rightOffset
                        showExpiredFilters
                        filters={filters}
                        onFilter={onFilter}
                    />
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({ url: `${mtAccountsRoute}/${EDIT}/0` }))}
                    >
                        {lang.add}
                    </Button>
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={accountList}
                    dataIds={accountIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="md"
                    showPagination
                    onSort={onSort}
                    onStatusChange={onStatusChange}
                />
            </PageContent>
        </Container>
    )
}
export default List
